import React from 'react';

const ConstructionMain = () => {
  return (
   <>
   
	{/* <!-- collapse-map starts --> */}
	<section className="collapse-ma pt-140 pb-140">
		<div className="welcome-txt text-center mb-5"><h4>Get House Construction Cost in Delhi</h4></div>
		<div className="far-cont container">
			
			<div className="row">
				<div className="col-lg-5 order-2 order-lg-1">
					
					<div className="far-txt pt-md-80">
						<p>
							Use our construction cost calculator, also known as construction cost estimator, to calculate the construction cost in Faridabad. From this calculator, you can get a general idea about the home construction cost on a plot in Faridabad as per your approximate plot size and home configuration.
					</p>
					<ul>
						<li><p className="d-flex">
							<span className="li-style">►</span>
							<span>
					Actual price quote for your project may vary depending on your construction area, selections for finishing items.
				</span>
				</p>
					</li>
					<li>
						<p className="d-flex">
							<span className="li-style">►</span>
							<span>
					 If you are working with a specific budget, our consultants can work with you to customize the project configuration for achieving your budget.
					</span>
				</p>

					</li>
					<li>
						<p className="d-flex">
							<span className="li-style">►</span>
							<span>
					Price range is for estimation purpose only. For the exact quote, please schedule a meeting with our home consultant by calling at <a href="#">9599818105</a>.
				</span>
				</p>
					</li>
					</ul>	
					</div>
				</div>
				<div className="col-lg-7 order-1 order-lg-2 pt-5 pb-4 px-4 bg-white shadow">
					<div className="far-form">
						<form action="" className="">
							<div className="row">
								<div className="col-md-6">
									<div className="mb-5">
										<label className="mb-3">Plot size in yards*</label>
									<select className="form-selec" aria-label="Default select example" required>
										<option className="d-none"></option>
										<option value="1">120</option>
										<option value="2">140</option>
										<option value="3">160</option>
									  </select>
									  </div>
								</div>
								<div className="col-md-6">
									<div className="mb-5">
										<label className="mb-3">I want to build*</label>
									<select className="form-selec" aria-label="Default select example">
										<option className="d-none"></option>
										<option value="1">One</option>
										<option value="2">Two</option>
										<option value="3">Three</option>
									  </select>
									  </div>
								</div>
								<div className="col-md-6 pt-4">
									<div className="mb-5">
										<label className="">City*</label>
										<input disabled type="text" value="delhi" className=""  required/>
									</div>
								</div>
								<div className="col-md-6">
									<div className="mb-5">
										<label className="">Total built up area that I want to build (in sq ft)*</label>
										<input placeholder="1000" type="number" className="" required/>
										<span>Please note this will be much more than your FAR area. Total built-up area includes FAR Area, Balcony, Stilt, Basement and Open Area. Please input your area number accordingly.</span>
									</div>
								</div>

								<div className="col-md-12">
									<div className="mb-5">
										<label className="mb-3">From where you hear about us? (select one from dropdown)</label>
									<select className="form-selec" aria-label="Default select example">
										<option className="d-none"></option>
										<option value="1">One</option>
										<option value="2">Two</option>
										<option value="3">Three</option>
									  </select>
									  </div>
								</div>
								<div className="col-md-12 ">
									<div className="mb-5">
										<label className="">Your Name*</label>
										<input type="text" className=""  required/>
									</div>
								</div>
								<div className="col-md-12 ">
									<div className="mb-5">
										<label className="">Your Email*</label>
										<input type="email"  required/>
	
									</div>
								</div>
								
								
								
								<div className="col-md-12">
									<div className="mb-5">
										<label className="">Mobile No.*</label>
										<input  type="text" className=""  required/>
									</div>
								</div>
								
								
								
								
	
	
							</div>
	
							<div className="col-md-12 text-center">
								
									<button className="btn-more3"  href="">Calculate FAR</button>
								
							</div>
	
						</form>
					</div>
				</div>
			</div>
		</div>
	</section>

	{/* <!-- collapse-map ends --> */}


	<section className="bg-white pt-60 pb-60">
		<div className="container">
			<div className="welcome-txt text-center mb-5"><h4>What is a Cost Construction Calculator?</h4></div>
			<div className="room-txt">
				<p>A Construction Cost Calculator is a crucial tool that is used for budgeting, cost control, and profit maximization. Our Construction Cost Calculator is easy to use and you don't need to be someone with a background in construction to understand its usefulness.</p>
				<br/>

					<p>It is a known fact that different countries or locations use different calculators to measure the cost of construction. ur legitimate Cost Construction Calculator can help you calculate the cost for plots in Faridabad.</p>
			</div>
		</div>
	</section>
	<section className="pt-60 pb-60">
		<div className="container">
			<div className="welcome-txt text-center mb-5"><h4>What is the importance of a Cost Construction Calculator?</h4></div>
			<div className="room-txt">
				<p>It is essential for every homeowner to understand the total cost of construction for their dream home. One reason is that it helps set realistic expectations against the estimated budget for a home in Faridabad. It also helps in providing a direction for all home-oriented decisions to be made in the future. This tool is also useful for professionals like architects, engineers, contractors, home builders, etc. to gauge the cost of construction in Delhi.</p>
				<br/>

					<p>Since planning the budget for any home is one of the integral steps for any homeowner, builder or buyer, this tool comes in very handy to make the process hassle-free for you.</p>
			</div>
		</div>
	</section>
	<section className="bg-white pt-60 pb-60">
		<div className="container">
			<div className="welcome-txt text-center mb-5"><h4>Factors on which the home construction cost in Faridabad depends on</h4></div>
			<div className="room-txt">
				<p className="d-flex"><span className="span-icn"></span> <span><span className="semi">Total Built Up Area:</span> The construction cost calculations for your plot in Faridabad will depend on the Covered Area, Half Covered Area, Basement and Open Area. The summation of these areas form the total built up area.</span>	</p>
				<br/>
				<p className="d-flex"><span className="span-icn"></span> <span><span className="semi">Covered Area:</span> It includes rooms, lift lobby, toilet, guard room,staircase, toilets, underground water tank, rain water harvesting pit, etc.</span>	</p>
				<br/>
				<p className="d-flex"><span className="span-icn"></span> <span><span className="semi">Half Covered Area:</span>  It includes balcony area, sunken courtyard, area with slab but not enclosed by wall like car parking area, etc.</span>	</p>
				<br/>
				<p className="d-flex"><span className="span-icn"></span> <span><span className="semi">Basement:</span> It includes retaining wall and staircase, lift shaft, lift lobby.</span>	</p>
				<br/>
				<p className="d-flex"><span className="span-icn"></span> <span><span className="semi">Open Area:</span>  It includes area of shaft/courtyard on each floor, area which is open to sky including the terrace, non-load bearing chajja area on each floor, etc.</span>	</p>
				<br/>

					<p>All these areas further depend on the FAR Consumption. Some families consume the full FAR of the plot and build the maximum number of floors on their plot, others might just want to build the number of floors in which their family can live comfortably in.</p>
			</div>
		</div>
	</section>


	<section className="pt-60 pb-60">
		<div className="container">
			<div className="welcome-txt text-center mb-5"><h4>Factors on which the home construction cost in Faridabad depends on</h4></div>
			<div className="room-txt">
				<p className="d-flex"><span className="span-icn"></span> <span><span className="semi">Total Built Up Area:</span> The construction cost calculations for your plot in Faridabad will depend on the Covered Area, Half Covered Area, Basement and Open Area. The summation of these areas form the total built up area.</span>	</p>
				<br/>
				<p className="d-flex"><span className="span-icn"></span> <span><span className="semi">Covered Area:</span> It includes rooms, lift lobby, toilet, guard room,staircase, toilets, underground water tank, rain water harvesting pit, etc.</span>	</p>
				<br/>
				<p className="d-flex"><span className="span-icn"></span> <span><span className="semi">Half Covered Area:</span>  It includes balcony area, sunken courtyard, area with slab but not enclosed by wall like car parking area, etc.</span>	</p>
				<br/>
				<p className="d-flex"><span className="span-icn"></span> <span><span className="semi">Basement:</span> It includes retaining wall and staircase, lift shaft, lift lobby.</span>	</p>
				<br/>
				<p className="d-flex"><span className="span-icn"></span> <span><span className="semi">Open Area:</span>  It includes area of shaft/courtyard on each floor, area which is open to sky including the terrace, non-load bearing chajja area on each floor, etc.</span>	</p>
				<br/>

					<p>All these areas further depend on the FAR Consumption. Some families consume the full FAR of the plot and build the maximum number of floors on their plot, others might just want to build the number of floors in which their family can live comfortably in.</p>
			</div>
		</div>
	</section>
	<section className="bg-photo pt-60 pb-60">
		<div className="wallpaper-overlay"></div>
		<div className="container cont-z">
<div className="row">
	<div className="col-md-6 order-2 order-md-1">
<div className="review-txt">
	<p><span className="semi-2 mb-5">Specifications of Interior and Exterior Finishing <br/>
	</span>
	<span className="mt-5">The construction cost calculations of a home in Faridabad also largely depend on the specifications which a family chooses for their home according to their taste and requirements. This includes the kind of kitchen the family might opt for (Modular or Normal), the kind of flooring they like (Italian Marble or Ceramic Tiles), the quality of bathroom fittings, whether they like stone cladding on the facade or extensive grillwork, etc.</span>	
		</p>
		<p><span className="semi-2">Quality/Brands of Construction Materials Used

		</span> <br/>
		Every material used in construction of a house comes in different qualities and from a variety of brands. After the quality parameters are met, it is usually the decision of the family, as to, which brand they would like to go for.
			</p>
</div>
	</div>
	<div className="col-md-6 order-1 order-md-2">
		<div className="constr-pic">
		<img width="100%" src="assets/Images/1dd5d482888175.5d2bb7895221a.jpg" alt=""/>
	</div>
	</div>
</div>
		</div>

	</section>

   </>
  )
}

export default ConstructionMain